<div>

  <mg-filter-form [filter]="filter" [formGroup]="form">

    <ng-container quickFilter>

      <!-- 1 date range selector -->

      <mat-form-field>
        <mat-label>Filter by date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate formControlName="startDate">
          <input matEndDate formControlName="endDate">
        </mat-date-range-input>
        <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

      </mat-form-field>

    </ng-container>

  </mg-filter-form>


</div>